import { Box } from '@mui/material';
// Components
import { FormikContextProvider } from '@components/formik';
import { ObLayout, Onboarding } from '@components';

const OnboardingPage = () => {
  return (
    <Box sx={{ bgcolor: '#f6f8fa' }}>
      <FormikContextProvider>
        <ObLayout>
          <Onboarding />
        </ObLayout>
      </FormikContextProvider>
    </Box>
  );
};

export default OnboardingPage;
